import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_gen_doc_to_irb_cancellation_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  processing_logic: fromDatatype.VarcharDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rejection_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  request_submission_status: fromDatatype.VarcharDatatypeInterface;
  cancellation_request_date: fromDatatype.TimestampTzDatatypeInterface;
  request_url: fromDatatype.VarcharDatatypeInterface;
  request_body: fromDatatype.TextDatatypeInterface;
  request_response: fromDatatype.TextDatatypeInterface;
  request_error: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_my_einvoice_gen_doc_to_irb_cancellation_queue_RowClass
  implements bl_fi_my_einvoice_gen_doc_to_irb_cancellation_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  processing_logic: fromDatatype.VarcharDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rejection_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  request_submission_status: fromDatatype.VarcharDatatypeInterface;
  cancellation_request_date: fromDatatype.TimestampTzDatatypeInterface;
  request_url: fromDatatype.VarcharDatatypeInterface;
  request_body: fromDatatype.TextDatatypeInterface;
  request_response: fromDatatype.TextDatatypeInterface;
  request_error: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
}
